import { useQuery } from "@tanstack/react-query";
import { PRICING_WORKLOAD_QUERY_KEY } from "../constants";
import { PricingWorkloadService } from "../services/PricingWorkload.service";

export default function useGetPricingWorkloads({
  userIds,
  enabled,
}: {
  userIds?: string[];
  enabled?: boolean;
}) {
  const { data, isLoading, error, isSuccess } = useQuery({
    queryKey: PRICING_WORKLOAD_QUERY_KEY(userIds),
    queryFn: () => PricingWorkloadService.getPricingWorkloads({ userIds }),
    enabled,
    refetchInterval: 2000,
  });

  return {
    pricingWorkloadData: data,
    isPricingWorkloadLoading: isLoading,
    pricingWorkloadError: error,
    isPricingWorkloadSuccess: isSuccess,
  };
}
